<template>
  <div>
    <zx-table
      :tableData="tableData"
      :option="table"
      :page="page"
      @searchSubmit="searchSubmit"
      @handleSelectionChange="handleSelectionChange"
      @delBtn="delBtn"
      @refresh-change="getlist"
      @addSubmit="addSubmit"
      @etidSubmit="etidSubmit"
      @refreshBtn="refreshBtn"
    ></zx-table>
    <el-dialog title="权限设置" :visible.sync="dialogVisible" width="30%">
      <el-tree
        node-key="menu_id"
        :data="treeData"
        :props="defaultProps"
        show-checkbox
        :default-checked-keys="auth"
        ref="tree"
      >
        <span class="custom-tree-node" slot-scope="{ data }">
          <span>{{ data.menu_name }}</span>
        </span>
      </el-tree>
      <div>
        <el-button @click="handleSubmit">设置权限</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as role from "@/api/role/role.js";
import * as menu from "@/api/menu/menu.js";
import xzTable from "@/components/xz-table.vue";
import {
  _setSessionStore,
  _getSessionStore,
  _removeSessionStore
} from "@/utils/storage";
import { tableInShow } from "@/assets/hasShow.js";
export default {
  name: "role-list",
  components: {
    "zx-table": xzTable
  },
  data() {
    return {
      defaultProps: {},
      dialogVisible: true,
      page: {
        total: 1,
        pagerCount: 1,
        currentPage: 1,
        pageSize: 10,
        pageSizes: [1, 3, 10, 20, 30, 40, 50, 100],
        // sizes, prev, pager, next, jumper, ->, total, slot
        // "layout":"prev, pager, next",
        layout: "total, sizes, prev, pager, next, jumper",
        background: true
      },
      table: {
        title: "角色",
        // 表格底部按钮
        btnBottom: false,
        // 操作按钮列定位 默认:false;
        fixed: false,
        // 子表格 默认: ; 数据格式:String;<对应子行字段名称>
        children: "children",
        // 多选 默认:false;
        // selection: false,
        // 单选高亮
        current: true,
        //搜索框 默认:false;
        searchBtn: false,
        // 表格高度 默认:100%; 数据格式:Number;
        // height:500,
        // 数边框 默认:false;
        border: false,
        //索引 默认:true;
        index: true,
        // 刷新 默认:true;
        refreshBtn: true,
        // 添加 默认:true;
        addBtn: true,
        // 编辑 默认:true;
        editBtn: true,
        // 删除  默认:true;
        delBtn: true,
        // 折叠筐 默认:false;
        expand: false,
        column: [
          {
            prop: "role_name",
            label: "名称",
            type: "input",
            layout: 12,
            hide: true
          },
          {
            layout: 12,
            prop: "role_key",
            label: "标识",
            type: "input",
            hide: true
          },
          {
            prop: "create_by",
            label: "创建人",
            type: "input",
            // 该字段是否可以在创建时编辑 默认:true;
            addDisplay: false,
            // 该字段是否可以修改默认true
            editDisplay: false,
            hide: true
          },
          {
            prop: "role_sort",
            label: "排序",
            type: "input",
            layout: 12,
            hide: true
          },
          {
            prop: "status",
            label: "状态",
            type: "radio",
            layout: 12,
            show: "tag",
            default: 0,
            options: [
              {
                text: "启用",
                value: 0
              },
              {
                text: "禁用",
                value: 1
              }
            ],
            tagtype: [
              {
                text: "启用",
                type: "success",
                value: 0
              },
              {
                text: "禁用",
                type: "danger",
                value: 1
              }
            ],
            hide: true
          },
          {
            prop: "remark",
            label: "描述",
            type: "textarea",
            hide: true
          },

          {
            prop: "create_time",
            label: "创建时间",
            // 该字段是否可以在创建时编辑 默认:true;
            addDisplay: false,
            // 该字段是否可以修改默认true
            editDisplay: false,
            hide: true
          },
          {
            prop: "update_time",
            label: "更新时间",
            // 该字段是否可以在创建时编辑 默认:true;
            addDisplay: false,
            // 该字段是否可以修改默认true
            editDisplay: false,
            hide: true
          }
        ],
        btnList: [
          {
            name: "权限",
            type: "text",
            show: false,
            click: (id, row, index) => {
              this.role_id = row.role_id;
              role.getRoleMenu.r({ id: row.role_id }).then(res => {
                this.treeData = res.menus;
                this.setTreeKeys(res.checked);
              });
              // this.$router.push({
              //   path: "/system/role/auth/" + id,
              //   query: {
              //     title: row.name
              //   }
              // });
            }
          }
        ]
      },
      role_id: -1,
      tableData: [],
      searchData: {},
      //
      dialogFormVisible: false,
      isShowSearch: true,
      searchFormData: {},
      searchFormDesc: {},
      httpGetType: 0,
      actBtnList: [
        {
          label: "新增",
          icon: "el-icon-plus",
          type: "success",
          size: "small",
          // state: false,
          state: false,
          action: () => {
            this.formData = {};
            this.dialogFormVisible = true;
          }
        }
      ],
      isShowIndex: true,
      isShowSelection: false,
      tableDesc: {
        class: {}, // 添加的类
        style: {}, // 添加的自定义样式
        attrs: {}, // 添加的自定义属性
        on: {} // 添加的自定义事件
      },
      tableCols: {
        name: {
          prop: "name",
          label: "名称",
          hide: true
        },
        guard_name: {
          prop: "guard_name",
          label: "标识",
          hide: true
        },
        description: {
          prop: "description",
          label: "描述",
          hide: true
        },
        create_time: {
          prop: "create_time",
          label: "创建时间",
          hide: true
        },
        update_time: {
          prop: "update_time",
          label: "更新时间",
          hide: true
        }
      },
      rightActionList: [],
      formData: {},
      formDesc: {
        name: {
          field: "name",
          label: "名称",
          type: "input",
          layout: 20,
          attrs: {
            size: "small",
            type: "text",
            showWordLimit: null,
            clearable: true,
            autofocus: false,
            validateEvent: true
          },
          required: true
        },
        guard_name: {
          field: "guard_name",
          label: "guard_name",
          type: "input",
          attrs: {
            size: "small",
            type: "text",
            showWordLimit: null,
            clearable: false,
            autofocus: false,
            validateEvent: true
          },
          required: true
        },
        description: {
          field: "description",
          label: "描述",
          type: "textarea",
          attrs: {
            rows: 3,
            autosizeType: "switch",
            autosize: false,
            showWordLimit: null,
            clearable: false
          }
        }
      },
      rules: {},
      apiUrl: role.getRoleList.p
    };
  },
  mounted: function() {
    let menuBtn = _getSessionStore("menuBtn", "JSONStr");

    this.getbutton();
  },
  created() {
    (this.dialogVisible = false), this.getlist();
  },
  methods: {
    setTreeKeys(e) {
      this.dialogVisible = true;
      let that = this;
      setTimeout(() => {
        that.$refs.tree.setCheckedKeys(e);
        // that.$refs.tree.setCheckedNodes(e);
      }, 200);
    },
    handleSubmit() {
      let postData = {
        role_id: this.role_id,
        menu_ids: [
          ...this.$refs.tree.getCheckedKeys(),
          ...this.$refs.tree.getHalfCheckedKeys()
        ]
      };
      console.log("this.role_id---", postData);
      console.log(
        "this.role_id---",
        this.$refs.tree.getCheckedNodes(true, true)
      );
      role.updateRole.r(postData).then(res => {
        this.dialogVisible = false;
        this.role_id = -1;
      });
    },
    handleCheckChange(e) {},
    getbutton() {
      this.rightActionList = [
        {
          label: "权限",
          show: true,
          attrs: {
            type: "success"
          },
          click: (id, index, row) => {
            this.formData = row;
            this.$router.push({
              path: "/role/auth/" + id,
              query: {
                title: row.name
              }
            });
          }
        },
        {
          label: "编辑",
          show: tableInShow(role.updateRole.p),
          click: (id, index, row) => {
            this.formData = row;
            this.dialogFormVisible = true;
            this.httpGetType = 1;
          }
        },
        {
          label: "删除",
          show: tableInShow(role.deleteRole.p),
          attrs: {
            type: "danger"
          },
          click: (id, index, row, data) => {
            this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
            })
              .then(() => {
                let postData = {
                  id: id
                };
                role.deleteRole
                  .r(postData)
                  .then(res => {
                    this.$message({
                      type: "success",
                      message: row.name + "删除成功!"
                    });
                    data.splice(index, 1);
                  })
                  .catch(() => {});
              })
              .catch(() => {
                this.$message({
                  type: "info",
                  message: "已取消删除"
                });
              });
          }
        }
      ];
    },
    // 添加提交
    addSubmit(form) {
      form["menu_ids"] = [2005]; // 2024, 2023
      role.addRole.r(form).then(res => {
        this.$message.success("账号" + res.role_name + "创建成功");
        this.getlist();
      });
    },
    // 编辑
    etidSubmit(form) {
      role.updateRole.r(form).then(res => {
        if (res.status) this.$message.success("修改成功");
        else this.$message.success("修改失败");
        this.getlist();
      });
    },
    // 删除
    delBtn(form) {
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          role.deleteRole.r({ role_id: form.role_id }).then(res => {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.getlist();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    //   多选
    handleSelectionChange(e) {},
    // 筛选条件
    searchSubmit(e) {
      this.searchData = e;
      if (e) {
        this.page.currentPage = 1;
      }
      this.getlist();
    },
    // 刷新
    refreshBtn(e) {
      this.getlist();
    },
    // 分页器
    refreshChange(e) {
      let that = this;
      setTimeout(() => {
        this.getlist();
      }, 1000);
    },
    getlist(e) {
      let param;
      let that = this;
      if (e) {
        that.page = e;
        param = {
          page: e.currentPage,
          limit: e.pageSize
        };
      } else {
        param = {
          page: this.page.currentPage,
          limit: this.page.pageSize
        };
      }
      if (this.searchData) {
        param = {
          page: this.page.currentPage,
          limit: this.page.pageSize,
          ...this.searchData
        };
      }
      role.getRoleList.r(param).then(res => {
        that.tableData = res.list;
        that.page.total = res.total;
      });
    }
    // setRightActionList(e){

    // 	let list = []
    // 	for(let i = 0; i<e.childrens.length;i++){
    // 		if(e.childrens[i].show_type==3){
    // 			let item = e.childrens[i]
    // 			list.push(
    // 				{
    // 					label: item.name,
    // 					attrs: {
    // 						type: "success"
    // 					},
    // 					click: (id, index, row) => {
    // 						this.formData = row;
    // 						this.$router.push({
    // 							path: "/role/auth/" + id,
    // 							query: {
    // 								title: row.name
    // 							}
    // 						});
    // 					}
    // 				},
    // 			)
    // 		}
    // 	}
    // 	// this.rightActionList

    // },
    // handleSubmit(data) {
    // 	// eslint-disable-next-line no-console
    // 	return Promise.resolve();
    // },
    // handleSuccess() {
    // 	let data = this.formData;
    // 	let type = this.httpGetType
    // 	if (type == 0) {
    //
    // 		role.addRole.r(data).then(res => {
    // 			this.$message.success("账号" + res.name + "创建成功");
    // 		})
    // 	} else {
    // 		data = {
    // 			"id": data.id,
    // 			"name": data.name,
    // 			"menu_set": data.menu_set,
    // 			"status": data.status,
    // 			"description": data.description,
    // 			"guard_name": data.guard_name
    // 		}
    // 		role.updateRole.r(data).then(res => {
    // 			if (res.status) this.$message.success("修改成功");
    // 			else this.$message.success("修改失败");
    // 		})
    // 	}
    // 	this.httpGetType = 0
    // 	this.dialogFormVisible = false;
    // 	this.formData = {};
    // }
  }
};
</script>

<style lang="scss" scoped>
.xvue-crud {
  th {
    word-break: break-word;
    color: rgba(0, 0, 0, 0.85);
    background-color: #fafafa;
  }

  .el-dialog {
    text-align: left;
  }

  .formD {
    text-align: left;
  }
}
</style>
